<app-location-admin-table [isAdminSearch]="false"></app-location-admin-table>
